<template>
    <div >
        <div class="d-print-none d-block">


        <br>
        <div class="container-fluid col-md-10" style="background:rgb(248,249,250); border-radius: 10px; box-shadow: 5px 5px 5px 5px #999999;" id="contenedor">
             <u @click="irMenu()">
				<br><h6>Volver</h6>
            </u>
            <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
            <h3 class="text-center" ><b>Generar vale</b></h3><br>
            <div class="d-flex justify-content-center">
            <div class="row">
                <div class="col"> <label>RUT Colaborador</label>
                    <div class="input-group mb-3">
                        
                         <input type="text" id="rut" class="form-control" placeholder="Ingrese RUT" style="border-color:rgb(237,126,37)"  @keyup="leer()" required>
                        <div class="input-group-append">
                           <button  id="btnBuscarTransferencia" class="btn btn-primary" @click="buscarColaborador()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search "></i></button>
                        </div>
                        </div>
                </div>
            </div>
            </div>

            <form id="formRegistrar" enctype="multipart/form-data" @submit.prevent="onFormSubmit" >
                 <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Nombre</label>
                        <input type="text" id="nombre" class="form-control" placeholder="Ingrese Nombre" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Área</label>
                        <input type="text" id="area" class="form-control" placeholder="Ingrese Área" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                   
                </div>    
                <br>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Sucursal</label>
                        <input type="text" id="sucursal" class="form-control" placeholder="Ingrese Sucursal" style="border-color:rgb(237,126,37)"   required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Razón</label>
                        <input type="text" id="razon" class="form-control" placeholder="Ingrese Razón Social" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                   
                </div>    
                <br>

                <div class="row">
                     <div class="col-sm-6">
                        <div class="form-group">
                         <label>Producto</label>
                            <select class="form-select" id="producto" @change="verPrecio()" aria-label="Default select example"  style="border-color: rgb(237, 126, 37);"></select>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Precio</label>
                        <input type="text" id="precio" class="form-control"  style="border-color:rgb(237,126,37)" readonly >
                        </div>
                    </div>
                </div><br>

                <div class="row">
                     <div class="col-sm-6">
                        <div class="form-group">
                        <label>Cantidad</label>
                        <input type="text" id="cantidad" v-on:keyup="calcularTotal()" class="form-control" placeholder="Ingrese cantidad" style="border-color:rgb(237,126,37)" >
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Total</label>
                        <input type="text" id="total" class="form-control"  style="border-color:rgb(237,126,37)" readonly >
                        </div>
                    </div>
                </div><br>    


                <div class="row">
                     <div class="col-sm-6">
                        <div class="form-group">
                         <label>Metodo Pago</label>
                        <select class="form-select" @change="revisarCupo()" aria-label="Default select example" id="metodoPago" style="border-color:rgb(237,126,37)">
                        <option value="-Seleccione-">-Seleccione-</option>
                        <option value="Desc. Planilla">Desc. Planilla</option>
                        <option value="Pago por Caja">Pago por Caja</option>
                        </select>
                        </div>
                    </div>
                    <br>
                   Cupo disponible: {{cupoDisponible}}/{{cupoTotal}}
                </div><br>
                

                <div class="row" id="rowArchivo" style="display:none">
                    
                    <div class="col-sm">
                      <label>Seleccionar archivo</label>
                        <input style="border-color:rgb(237,126,37)" id="archivo" @change="clickImagen($event)" type="file" accept="file/*" ><br>
                </div>
                </div><br>
               
                <div class="row">
                    <div class="col-sm">
                        <div class="form-group">
                            <label for="observacion">Observación (Número de Vales)</label>
                            <textarea class="form-control" id="observacion" rows="3"  style="border-color:rgb(237,126,37)" required></textarea><br>
                        </div>
                    </div>
                    
                </div>
                <br>
                <!--<div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" rows="3" v-model="cheque.observacion" style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>-->
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button id="botonRegistrar" class="btn btn-primary btn-block" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Registrar</button><br><br>
                    </div>
                </div>

            </form>
        </div>
    </div> 
    <div class="d-print-block d-none"><br>
    <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="100" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
         <div class="d-flex justify-content-center">
                    <h5><b>Autorización Préstamo Empresa</b></h5><br><br>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div class="d-flex justify-content-start">
                          <h6>Constancia de Recibo y Autorización:</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>En San Javier a {{fechaPrint}}, yo {{nombrePrint}}, Rut: {{rutPrint}} en calidad de trabajador, declaro haber recibido de {{razonPrint}}. Rut: {{rutRazonPrint}}, quien actúa en calidad de empleador la suma de $ {{montoPrint}}, sin intereses.</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>Por lo anterior, autorizo a {{razonPrint}}. Rut: {{rutRazonPrint}} para que realice descuentos de mis remuneraciones de sueldo.</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                         <h6>
                        -Dicho préstamo será descontado en un total de 1 cuota por un valor de ${{montoPrint}} de las liquidaciones haciendo referencia al CONVENIO BIENESTAR {{numeroConvenio}}.
                          </h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                         
                          <h6>
                            -Asimismo, si se diera termino al contrato de trabajo de manera anticipada, autorizo expresamente al empleador a descontar de mi Liquidación de Sueldo y/o Finiquito, los valores que correspondan a saldos adeudados de dicho préstamo.
                          </h6>
        </div>
            </div> <div class="col-sm-1"></div>
        </div><br><br><br>
        <div class="row">
            <div class="col-sm-2"></div>
             <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA EMPLEADOR</h6><br>
               </span>
              </div>    
             </div>
              
            <div class="col-sm-2"></div> 
            
            <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA TRABAJADOR</h6><br>
               </span>
              </div> 
            </div>
            <div class="col-sm-2"></div>
        </div>
        


    </div>

    <div class="d-print-block d-none"><br><br><br><br>
    <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="100" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
         <div class="d-flex justify-content-center">
                    <h5><b>Autorización Préstamo Empresa</b></h5><br><br>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div class="d-flex justify-content-start">
                          <h6>Constancia de Recibo y Autorización:</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>En San Javier a {{fechaPrint}}, yo {{nombrePrint}}, Rut: {{rutPrint}} en calidad de trabajador, declaro haber recibido de {{razonPrint}}. Rut: {{rutRazonPrint}}, quien actúa en calidad de empleador la suma de $ {{montoPrint}}, sin intereses.</h6>
                          
        </div>
            </div> <div class="col-sm-1">
                
            </div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>Por lo anterior, autorizo a {{razonPrint}}. Rut: {{rutRazonPrint}} para que realice descuentos de mis remuneraciones de sueldo.</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                         <h6>
                        -Dicho préstamo será descontado en un total de 1 cuota por un valor de ${{montoPrint}} de las liquidaciones haciendo referencia al CONVENIO BIENESTAR {{numeroConvenio}}.
                          </h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                         
                          <h6>
                            -Asimismo, si se diera termino al contrato de trabajo de manera anticipada, autorizo expresamente al empleador a descontar de mi Liquidación de Sueldo y/o Finiquito, los valores que correspondan a saldos adeudados de dicho préstamo.
                          </h6>
        </div>
            </div> <div class="col-sm-1"></div>
        </div><br><br><br>
        <div class="row">
            <div class="col-sm-2"></div>
             <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA EMPLEADOR</h6><br>
               </span>
              </div>    
             </div>
              
            <div class="col-sm-2"></div> 
            
            <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA TRABAJADOR</h6><br>
               </span>
              </div> 
            </div>
            <div class="col-sm-2"></div>
        </div>
        


    </div>
    </div>
</template>
<script type="text/javascript"
    src="https://cdn.jsdelivr.net/npm/emailjs-com@3/dist/email.min.js">
</script>
<script type="text/javascript">
  (function(){
    emailjs.init("j3lmgrv_03DynNi_3");
  })();
  </script>
<script>
    //import firebase from "firebase/app";
    import { db } from '../firebaseDb';
    import {storage} from '../firebaseDb';
    import Swal from 'sweetalert2'
    var sd = require('silly-datetime');
    const ref=storage.ref()
    //var nodemailer = require('nodemailer');

    export default {
        data() {
            return {
                vale: {
                },
                imagen:null,
                imagenes:[],
                usuario:'',
                fecha:'',
                hora:'',
                productos:[],
                stockSeleccionado:0,
                cupoDisponible:0,
                cupoTotal:0,
                fechaPrint:'',
                nombrePrint:'',
                rutPrint:'',
                razonPrint:'',
                rutRazonPrint:'',
                montoPrint:'',
                imagen:null,
                numeroConvenio:'',
                cantidadSolicitudesReserva:0,
                
            }
        },
        created() {
            this.cargarProductos()
            document.getElementById("nav").style.display="block";
            this.usuario=localStorage.nombreUsuario;
            this.sucursal=localStorage.sucursal;
            this.obtenerFecha();
            this.validarUsuario();
        },
        methods: {
            clickImagen(e){
               this.imagen=e.target.files[0];  
               //console.log(this.imagen)
            },
            subirImagen(nombreImg){
                //referencia de subida
                const refImg=ref.child('comprobantes/'+nombreImg)
                const metadata={contentType:'application/pdf'}
                refImg.put(this.imagen,metadata)
                .then(e=>console.log(e))
                    document.getElementById("archivo").value="";
                    this.imagen=null;
                //setTimeout(this.verFoto, 5000,""); 
                
            },
            irMenu(){
                if(localStorage.tipoUsuario=="1"){
                    this.$router.push('/menu')
                }else if(localStorage.tipoUsuario=="2"){
                    this.$router.push('/menutransportes')
                }
            },
            verPrecio(){
                var producto=document.getElementById("producto").value
                
                 db.collection('productos').where("sku", "==", producto).onSnapshot((snapshotChange) => {
                //this.productos = [];
                    snapshotChange.forEach((doc) => {
                        //console.log(doc.data())
                        document.getElementById("precio").value=doc.data().precio
                        this.stockSeleccionado=doc.data().stock
                        this.numeroConvenio=doc.data().convenio
                        this.validarStockReservas(doc.data().descripcion)
                    }) 
                })
            },
            validarStockReservas(descripcion){
                db.collection('pedido').where("estado", "==", "Pendiente").where("descripcion", "==", descripcion).orderBy("fr","desc").onSnapshot((snapshotChange) => {
                    this.cantidadSolicitudesReserva =0;
                    if(snapshotChange.empty){
                        this.cantidadSolicitudesReserva=0;
                    }else{
                        snapshotChange.forEach((doc) => {
                             this.cantidadSolicitudesReserva=parseInt(this.cantidadSolicitudesReserva)+parseInt(doc.data().cantidad);
                    });
                 }
                })      
            },
            actualizarStock(sku,cantidad,observacion,usuario,fecha,hora,fr,nombre){
                  var x=new Object
                  x.sku=sku  
                  x.cantidad=parseInt(cantidad)*parseInt(-1)
                  x.observacion=observacion 
                  x.usuario=usuario 
                  x.fecha=fecha 
                  x.hora=hora
                  x.fr=fr
                  x.sucursal="Centro Comercial"
                  x.persona=nombre
                  x.tipo="SALIDA"

                 db.collection('stock').add(x).then(() => {
                        //console.log("movimiento registrado")
                        this.actualizarStock2(sku,cantidad)
                    }).catch((error) => {
                        console.log(error);
                    });
            },
            actualizarStock2(sku,cantidad){
                db.collection("productos").where("sku", "==", sku).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                       // console.log(doc.id, " => ", doc.data());
                        var dif=parseInt(doc.data().stock)-parseInt(cantidad)
                      //  console.log(doc.id)
                        db.collection('productos').doc(doc.id)
                        .update({stock: dif}).then(() => {
                           // console.log("Producto actualizado");
                            //this.$router.push('/list')
                        }).catch((error) => {
                            console.log(error);
                        });
                    });
                });
               
            },

            calcularTotal(){
                var cantidad=document.getElementById("cantidad").value;
                if(cantidad<=this.stockSeleccionado){
                    var precio=document.getElementById("precio").value
                    var total=parseInt(cantidad)*parseInt(precio)
                    document.getElementById("total").value=total;
                }else{
                    document.getElementById("total").value="0";
                    Swal.fire({
                        title: "Error",
                        text: "Debe ingresar una cantidad menor o igual al stock disponible",
                        icon: "error",
                    });
                }
            },

            buscarColaborador(){
                var rut=document.getElementById("rut").value.replaceAll(".","").toUpperCase();
               // console.log(rut)
                db.collection("colaborador").where("rut", "==", rut).get().then((querySnapshot) => {
                    //console.log(querySnapshot.empty)
                    if(querySnapshot.empty!=true){
                        querySnapshot.forEach((doc) => {
                            //console.log(doc.data())
                            document.getElementById("nombre").value=doc.data().nombre;
                            document.getElementById("area").value=doc.data().area;
                            document.getElementById("sucursal").value=doc.data().sucursal;
                            document.getElementById("razon").value=doc.data().razon;
                            this.cupoDisponible=doc.data().cupodisponible;
                            this.cupoTotal=doc.data().cupo;

                            this.fechaPrint=this.fecha
                            this.nombrePrint=doc.data().nombre;
                            this.rutPrint=doc.data().rut;
                            this.razonPrint=doc.data().razon;
                            this.rutRazonPrint=doc.data().rutrazon;
                        });
                    }else{
                        Swal.fire({
                            title: "Error",
                            text: "No se encontró colaborador",
                            icon: "error",
                        });
                    }
                    
                });
                
                this.obtenerFecha();
            },

            revisarCupo(){
                var metodoPago=document.getElementById("metodoPago").value;
                var total= document.getElementById("total").value;
                if(metodoPago=="Desc. Planilla"){
                    document.getElementById("rowArchivo").style.display="none"
                    if(parseInt(this.cupoDisponible)>=parseInt(total)){
                        document.getElementById("botonRegistrar").style.display="block"
                    }else{
                        Swal.fire({
                            title: "Error",
                            text: "El monto total excede el cupo del trabajador",
                            icon: "error",
                        });
                        document.getElementById("botonRegistrar").style.display="none"
                        
                    }
                }else if(metodoPago=="Pago por Caja"){
                    document.getElementById("botonRegistrar").style.display="block"
                    document.getElementById("rowArchivo").style.display="block"
                }else{
                    document.getElementById("botonRegistrar").style.display="block"
                    document.getElementById("rowArchivo").style.display="none"    
                }
            },

            actualizarCupo(rut,nuevoCupo){
                //console.log("acaaa")
                //console.log(rut,nuevoCupo)
                db.collection("colaborador").where("rut", "==", rut).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());
                        //var dif=parseInt(doc.data().stock)-parseInt(cantidad)
                       // console.log(doc.id)
                        db.collection('colaborador').doc(doc.id)
                        .update({cupodisponible: nuevoCupo}).then(() => {
                            //console.log("Cupo actualizado");
                            //this.$router.push('/list')
                        }).catch((error) => {
                            console.log(error);
                        });
                    });
                });
            },


           
            onFormSubmit(event) {
                if(document.getElementById("rut").value!="" && 
                document.getElementById("nombre").value!="" &&
                document.getElementById("area").value!="" &&
                document.getElementById("sucursal").value!="" &&
                document.getElementById("razon").value!="" &&
                document.getElementById("producto").value!="-Seleccione-" &&
                document.getElementById("precio").value!="0" &&
                document.getElementById("precio").value!="" &&
                document.getElementById("cantidad").value!="" &&
                document.getElementById("total").value!="0" &&
                document.getElementById("total").value!="" &&
                document.getElementById("metodoPago").value!="-Seleccione-"
                ){
                    var cantidadvalidar=document.getElementById("cantidad").value
                    var xxvalidacionxx=parseInt(this.cantidadSolicitudesReserva)+parseInt(cantidadvalidar)
                    console.log(xxvalidacionxx)
                    if(parseInt(this.stockSeleccionado)>=xxvalidacionxx){
                        console.log(this.stockSeleccionado,this.cantidadSolicitudesReserva)    
                   event.preventDefault()
                    var metodoPago=document.getElementById("metodoPago").value;
                    var total= document.getElementById("total").value;
                    if(metodoPago=="Desc. Planilla"){
                        if(parseInt(this.cupoDisponible)>=parseInt(total)){
                            this.vale.usuario=this.usuario;
                            this.vale.fecha=this.fecha;
                            this.vale.hora=this.hora;
                            this.vale.estado='pendiente';
                            this.vale.rut = document.getElementById("rut").value.toUpperCase().replaceAll(".","") 
                            this.vale.nombre = document.getElementById("nombre").value
                            this.vale.area = document.getElementById("area").value
                            this.vale.sucursal = document.getElementById("sucursal").value
                            this.vale.sucursalEntrega = "Centro Comercial"
                            this.vale.razon = document.getElementById("razon").value
                            this.vale.producto = document.getElementById("producto").value
                            this.vale.precio = document.getElementById("precio").value.toUpperCase() 
                            this.vale.cantidad = document.getElementById("cantidad").value
                            this.vale.total = document.getElementById("total").value
                            this.vale.observacion = document.getElementById("observacion").value
                            this.vale.metodoPago = document.getElementById("metodoPago").value
                            this.vale.fr = this.año+this.mes+this.dia
                            var rut=document.getElementById("rut").value.toUpperCase().replaceAll(".","") 
                            var sku=document.getElementById("producto").value
                            var cantidad=document.getElementById("cantidad").value
                            var observacion= document.getElementById("observacion").value
                            var usuario=this.usuario;
                            var fecha=this.fecha;
                            var hora=this.hora;
                            var fr=this.año+this.mes+this.dia
                            var nombre=document.getElementById("nombre").value
                            this.montoPrint=document.getElementById("total").value;

                            db.collection('vale').add(this.vale).then(() => {
                            //this.montoPrint=this.vale.total
                            var nuevoCupo=parseInt(this.cupoDisponible)-parseInt(total)
                            this.actualizarStock(sku,cantidad,observacion,usuario,fecha,hora,fr,nombre)    
                            this.actualizarCupo(rut,nuevoCupo)

                            document.getElementById("rut").value=""
                            document.getElementById("nombre").value=""
                            document.getElementById("area").value=""
                            document.getElementById("sucursal").value=""
                            document.getElementById("razon").value=""
                            document.getElementById("precio").value=""
                            document.getElementById("cantidad").value=""
                            document.getElementById("total").value=""
                            document.getElementById("observacion").value=""
                            this.cupoTotal=0
                            this.cupoDisponible=0
                            window.print()
                            Swal.fire({
                                title: "Listo",
                                text: "Gestión Registrada",
                                icon: "success",
                            })

                            }).catch((error) => {
                                console.log(error);
                            });
                        }else{
                             Swal.fire({
                                title: "Error",
                                text: "El cupo disponible es menor que el total",
                                icon: "error",
                            });
                        }
                    }else{
                        if(this.imagen!=null){
                            this.vale.usuario=this.usuario;
                            this.vale.fecha=this.fecha;
                            this.vale.hora=this.hora;
                            this.vale.estado='pendiente';
                            this.vale.rut = document.getElementById("rut").value.toUpperCase() 
                            this.vale.nombre = document.getElementById("nombre").value
                            this.vale.area = document.getElementById("area").value
                            this.vale.sucursal = document.getElementById("sucursal").value
                            this.vale.sucursalEntrega = "Centro Comercial"
                            this.vale.razon = document.getElementById("razon").value
                            this.vale.producto = document.getElementById("producto").value
                            this.vale.precio = document.getElementById("precio").value.toUpperCase() 
                            this.vale.cantidad = document.getElementById("cantidad").value
                            this.vale.total = document.getElementById("total").value
                            this.vale.observacion = document.getElementById("observacion").value
                            this.vale.metodoPago = document.getElementById("metodoPago").value
                            var nombreImg=document.getElementById("rut").value.toUpperCase()+document.getElementById("producto").value+document.getElementById("producto").value+this.año+this.mes+this.dia+this.hora+this.imagen.name;
                            this.vale.imagen=nombreImg
                            this.vale.fr = this.año+this.mes+this.dia
                            console.log(this.año+this.mes+this.dia)
                            var sku=document.getElementById("producto").value
                            var cantidad=document.getElementById("cantidad").value
                            var observacion= document.getElementById("observacion").value
                            var usuario=this.usuario;
                            var fecha=this.fecha;
                            var hora=this.hora;
                            var fr=this.año+this.mes+this.dia
                            var nombre=document.getElementById("nombre").value
                            db.collection('vale').add(this.vale).then(() => {
                            this.actualizarStock(sku,cantidad,observacion,usuario,fecha,hora,fr,nombre)    
                            this.subirImagen(nombreImg)
                            document.getElementById("rut").value=""
                            document.getElementById("nombre").value=""
                            document.getElementById("area").value=""
                            document.getElementById("sucursal").value=""
                            document.getElementById("razon").value=""
                            document.getElementById("precio").value=""
                            document.getElementById("cantidad").value=""
                            document.getElementById("total").value=""
                            document.getElementById("observacion").value=""
                            this.cupoTotal=0
                            this.cupoDisponible=0
                            Swal.fire({
                                title: "Listo",
                                text: "Gestión Registrada",
                                icon: "success",
                            })

                            }).catch((error) => {
                                console.log(error);
                            });
                        }else{
                            Swal.fire({
                                title: "Error",
                                text: "Debe adjuntar el comprobante de pago",
                                icon: "error",
                            })
                        }
                        

                    }     


                }else{
                    Swal.fire({
                                title: "Error",
                                text: "El stock disponible es solo para las solicitudes de reserva "+"("+this.cantidadSolicitudesReserva+")",
                                icon: "error",
                            })
                }



                }else{

                    Swal.fire({
                                title: "Error",
                                text: "Debe completar los campos de manera correcta",
                                icon: "error",
                            })
                }
                
                
                    
            },
            cambioTipoMonto(){
                /*
                var tipo=document.getElementById("tipoMonto").value
                console.log(tipo)
                if(tipo=="Parcial"){
                    document.getElementById("pagoParcial").style.display="block"
                }else{
                    document.getElementById("pagoParcial").style.display="none"
                }
                */
            },
            buscarTransferencia(){
                var id=document.getElementById("idTransaccion").value.toUpperCase() 
                console.log(id)
                if(id!=""){
                    db.collection('transacciones').where("id", "==", id).get().then((doc) => {
                    console.log(doc.docs.length)
                    if (doc.docs.length>0) {
                       document.getElementById("formRegistrar").style.display="none"
                        Swal.fire({
                            title: 'Aviso',
                            text: 'Ya existe una transacción registrada con esta ID',
                            icon: 'info'
                        })
                    } else {
                        // doc.data() will be undefined in this case
                       document.getElementById("formRegistrar").style.display="block"
                    }
                }).catch((error) => {
                    console.log(error);
                });   

                }else{
                    document.getElementById("formRegistrar").style.display="none"
                     Swal.fire({
                            title: 'Aviso',
                            text: 'Debe ingresar una ID de transferencia',
                            icon: 'info'
                        })
                }
                
                /*
                db.collection('transacciones').where("id", "==", id).onSnapshot((snapshotChange) => {
                   console.log(snapshotChange)
                if(snapshotChange.empty==false){
                 document.getElementById("formRegistrar").style.display="none"
                  Swal.fire({
                    title: 'Aviso',
                    text: 'Ya existe una transacción registrada con esta ID',
                    icon: 'info'
                    })
                }else{
                    document.getElementById("formRegistrar").style.display="block"
                }
               
                })*/

            },

            clickImagen(e){
               this.imagen=e.target.files[0];  
               console.log(this.imagen)   
            },
            /*subirImagen(){
                //referencia de subida
                const refImg=ref.child('imagenes/'+this.imagen.name)
                const metadata={contentType:'img/jpeg'}
                refImg.put(this.imagen,metadata)
                .then(e=>console.log(e))
                    document.getElementById("archivo").value="";
                    this.imagen=null;
                setTimeout(this.verFoto, 5000,""); 
                
            },*/
            verFoto(imagen) {
                console.log(imagen)
            },
           
        obtenerFecha(){
            this.fecha=sd.format(new Date(), 'DD-MM-YYYY');
            this.dia=(sd.format(new Date(), 'DD'))
            this.mes=(sd.format(new Date(), 'MM'))
            this.año=(sd.format(new Date(), 'YYYY'))
            this.hora=sd.format(new Date(), 'HH:mm');
        },
        validarUsuario(){
             //document.getElementById("monto").display = "none";   
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },
        
        cargarProductos(){
                
              //  var vendedor = document.getElementById("vendedores")
                db.collection('productos').where("estado", "==", "ACTIVO").where("convenio", "==", 1).orderBy('descripcion').onSnapshot((snapshotChange) => {
                document.getElementById("producto").innerHTML=""
                this.productos = [];
                snapshotChange.forEach((doc) => {
                   // console.log(doc)
                    if(doc.data().sku=="-"){
                        var option = document.createElement("option")
                        option.value = doc.data().sku,
                        option.innerHTML = doc.data().descripcion,
                        document.getElementById("producto").appendChild(option)
                    }else{
                        
                        var option = document.createElement("option")
                        option.value = doc.data().sku,
                        option.innerHTML = doc.data().descripcion+" | stock:"+doc.data().stock,
                        document.getElementById("producto").appendChild(option)
                        this.stockSeleccionado=doc.data().stock
                    }
                    
                    /*this.vendedores.push({
                        key: doc.id,
                        nombre: doc.data().nombre,
                        rut: doc.data().rut,
                        
                    })*/
                });
            })
            },    

        leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        },
        leer2(){
                var rut = document.getElementById("rutFacturacion").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rutFacturacion").value=(rut2+"-"+rut3)
				
        },

        





        }
    }
</script>